import { MenuItem, Select } from '@mui/material';
import React from 'react';
import { CurvePreferences } from '../../config/plotTypes';

interface MainCurveDropdownProps {
  value: string;
  curves: Record<string, CurvePreferences>;
  onChange: (value: string) => void;
}

export const MainCurveDropdown: React.FC<MainCurveDropdownProps> = ({
  value,
  curves,
  onChange,
}) => {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      size="small"
      fullWidth
    >
      {Object.entries(curves).map(([curveKey, curvePrefs]) => (
        <MenuItem key={curveKey} value={curveKey}>
          {curvePrefs.displayName || curveKey}
        </MenuItem>
      ))}
    </Select>
  );
};
